export default "__VITE_PUBLIC_ASSET__20e7eee9__"